const NETATMO_RATE_LIMITED = '100';
export const NETATMO_USER_LINK_NOT_FOUND = '101';
const NETATMO_ACCOUNT_REVOKED = '102';
const NETATMO_NOT_FOUND = '103';

const FORECAST_NOT_AVAILABLE_FOR_STATION = '204';

/**
 * DRF's 429 (backend #282: the point forecasts; `useApiClient` also leaves the
 * endpoint alone until its Retry-After has passed). No snackbar, which would
 * otherwise come back on every background refresh: the screen keeps what it
 * shows (FE #404). The password link and the re-authentication read the 429
 * themselves; a call the user asked for says why with `isThrottled` and
 * `throttledAlert` (`useApiClient`, FE #427), as the snackbar no longer does.
 */
const THROTTLED = 'throttled';

export const HANDLED_ERROR_CODES = [
  NETATMO_RATE_LIMITED,
  NETATMO_USER_LINK_NOT_FOUND,
  NETATMO_ACCOUNT_REVOKED,
  NETATMO_NOT_FOUND,
  FORECAST_NOT_AVAILABLE_FOR_STATION,
  THROTTLED,
];
